<template>
  <span @click="changeSortValue"> {{ $t(item.label) }} </span>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    changeSortValue () {
      this.$bus.$emit('change-sort-data', { id: this.item.id, value: this.item.value, status: this.item.status })
    }
  }
}
</script>
